<template>
  <div>
    <v-btn text icon class="mb-2"
      :to="{ name: 'elaboracao-cardapio', params: { identificadortitulocardapio: form.identificadortitulocardapio } }">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" class="mt-4" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <v-card class="mt-5">
      <v-toolbar color="blue" dark class="mb-2">
        <v-toolbar-title>Novo Lançamento no Cardápio</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.identificadortitulocardapio">
              <v-autocomplete
                slot-scope="{ props }"
                v-bind="props"
                :items="cardapioOptions"
                item-text="value"
                item-value="key"
                disabled
                background-color='#f2f2f2'
                outlined
                label="Cardápio*"
                no-data-text="Opções não disponíveis"
                v-model="form.identificadortitulocardapio"
              ></v-autocomplete>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.anocardapio">
              <v-autocomplete
                slot-scope="{ props }"
                v-bind="props"
                :items="anoOptions"
                item-text="value"
                item-value="key"
                :disabled="!form.identificadortitulocardapio || loading"
                :background-color="!form.identificadortitulocardapio || loading ? '#f2f2f2' : null"
                outlined
                label="Ano*"
                no-data-text="Opções não disponíveis"
                v-model="form.anocardapio"
              ></v-autocomplete>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.semanacardapio">
              <v-autocomplete
                slot-scope="{ props }"
                v-bind="props"
                :items="semanaOptions"
                item-text="value"
                item-value="key"
                :disabled="!form.identificadortitulocardapio || loading"
                :background-color="!form.identificadortitulocardapio || loading ? '#f2f2f2' : null"
                outlined
                label="Semana*"
                no-data-text="Opções não disponíveis"
                v-model="form.semanacardapio"
              ></v-autocomplete>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.indicaturnocardapio">
              <v-autocomplete
                slot-scope="{ props }"
                v-bind="props"
                :items="turnoOptions"
                item-text="value"
                item-value="key"
                :disabled="!form.identificadortitulocardapio || loading"
                :background-color="!form.identificadortitulocardapio || loading ? '#f2f2f2' : null"
                outlined
                label="Turno*"
                no-data-text="Opções não disponíveis"
                v-model="form.indicaturnocardapio"
              ></v-autocomplete>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.indicarefeicaocardapio">
              <v-autocomplete
                slot-scope="{ props }"
                v-bind="props"
                :items="refeicoesOptions"
                item-text="value"
                item-value="key"
                :disabled="!form.identificadortitulocardapio || loading"
                :background-color="!form.identificadortitulocardapio || loading ? '#f2f2f2' : null"
                outlined
                label="Refeição*"
                no-data-text="Opções não disponíveis"
                v-model="form.indicarefeicaocardapio"
              ></v-autocomplete>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="6">
            <Validate :v="$v.form.horacardapio">
              <v-text-field
                slot-scope="{ props }"
                v-bind="props"
                label="Horário*"
                v-model="form.horacardapio"
                type="time"
                :disabled="!form.identificadortitulocardapio || loading"
                :background-color="!form.identificadortitulocardapio || loading ? '#f2f2f2' : null"
                outlined>
              </v-text-field>
            </Validate>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col lg="12">
            <div class="bloco-btn" style="text-align: right">
              <v-btn class="rounded-sm font-weight-regular mr-3" color="teal" :dark="!loading && formUltimo != null" tile :disabled="loading || !formUltimo"
                @click="copiarUltimo">Copiar último</v-btn>
              <v-btn class="rounded-sm font-weight-regular" color="teal" dark tile :loading="loading"
                @click="onSubmit">Salvar</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0">
      <div class="d-flex justify-space-between align-center">
          <span> {{ submitText }}</span>
          <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const CardapioRepository = RepositoryFactory.get("cardapio");

import { mapGetters } from 'vuex';

const setFormInicial = () => ({
  identificadortitulocardapio: '',
  anocardapio: '',
  semanacardapio: '',
  indicaturnocardapio: '',
  indicarefeicaocardapio: '',
  horacardapio: null
});

export default {
  name: 'MontaCardapio',
  data() {
    return {
      form: setFormInicial(),
      formUltimo: null,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      loading: false,
      cardapioOptions: [],
      semanaOptions: [
        { key: 1, value: '1º Semana' },
        { key: 2, value: '2º Semana' },
        { key: 3, value: '3º Semana' },
        { key: 4, value: '4º Semana' },
      ],
      turnoOptions: [
        { key: 'M', value: 'Matutino' },
        { key: 'V', value: 'Vespertino' },
        { key: 'N', value: 'Noturno' },
        { key: 'I', value: 'Integral' },
      ],
      refeicoesOptions: [
        { key: 1, value: 'Entrada' },
        { key: 2, value: 'Lanche' },
        { key: 3, value: 'Almoço' },
        { key: 4, value: 'Jantar' },
      ],
    };
  },
  validations: {
    form: {
      identificadortitulocardapio: { required, integer },
      anocardapio: { required, integer },
      semanacardapio: { required, integer },
      indicaturnocardapio: { required },
      indicarefeicaocardapio: { required, integer },
      horacardapio: { required },
    }
  },

  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema']),

    anoOptions() {
      let retornoOptions = [];
      for(let i = new Date().getFullYear() + 1; i >= 2023; i--) {
        retornoOptions.push({ key: i, value: i });
      }
      return retornoOptions;
    },
  },

  async mounted() {
    const { cardapio } = this.$route.params;

    if (!cardapio) {
      this.$router.push('/elaboracao-cardapio')
      return
    }
    this.form.identificadortitulocardapio = cardapio.identificadortitulocardapio
    this.cardapioOptions = [
      { key: cardapio.identificadortitulocardapio, value: cardapio.descricaotitulocardapio }
    ]
    this.$Progress.finish();
  },

  methods: {
    async onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) { return }

      this.loading = true
      this.msgArrayError = []
      // await new Promise(resolve => setTimeout(resolve, 1000))

      try {
        const { data } = await CardapioRepository.criarCardapio(this.form);

        this.submitText = 'Salvo com sucesso'
        this.snackbar = true
        this.loading = false
        this.formUltimo = { ...this.form }
        this.form = { ...this.form, anocardapio: '',semanacardapio: '',indicaturnocardapio: '',indicarefeicaocardapio: '',horacardapio: null}
        this.$v.$reset()
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    copiarUltimo() {
      this.form = { ...this.formUltimo }
    }
  },
};
</script>

<style lang="scss" scoped>
.input-block {
  width: 100%;
}
</style>
